import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import defaultApi from '../../api/defaultApi';
import { reproducir, sonidoVip } from './sonidoAlerta';

/** Cada cuanto se consulta: el proceso VIP del backend corre cada 5 segundos. */
const INTERVALO_MS = 5000;

/** Texto del icono segun cuantas alertas VIP hay sin atender. */
export const tituloVip = (n) => (n === 1
    ? '1 alerta VIP (pánico) sin atender · ir a Operador'
    : `${n} alertas VIP (pánico) sin atender · ir a Operador`);

/** Suena cuando aumentan las alertas VIP sin atender, salvo que el usuario ya esté en Operador. */
export const debeSonar = (antes, ahora, hash) => ahora > antes && !String(hash || '').includes('/components/operador');

/**
 * Icono rojo que titila en el topbar mientras el usuario tenga alertas SERVICIO_VIP (pánico de un equipo VIP) sin
 * atender, en cualquier pantalla. Al tocarlo lleva a la pantalla Operador, donde se atienden. Sin alertas no se ve.
 * Pedido de Roberto 28/10: que se note sin tener que estar en Operador.
 */
const AlertaVipIndicador = () => {

    const navigate = useNavigate();
    const timer = useRef(null);
    const anterior = useRef(0);
    const [activas, setActivas] = useState(0);

    const leer = useCallback(async () => {
        const jwt = localStorage.getItem('jwt');
        if (!jwt || jwt.replaceAll('"', '').length === 0) return;
        if (typeof document !== 'undefined' && document.hidden) return;
        try {
            const res = await defaultApi.get('/monitoreo/vip-activas');
            const n = res?.data?.activas ?? 0;
            // Pánico VIP nuevo: suena la sirena VIP en cualquier pantalla. En Operador no, porque esa pantalla
            // ya la hace sonar al listar la alerta y sonaría doble.
            if (debeSonar(anterior.current, n, window.location.hash)) reproducir(sonidoVip);
            anterior.current = n;
            setActivas(n);
        } catch (e) {
            // un error de red no rompe el topbar: queda el ultimo valor y se reintenta en el siguiente ciclo
        }
    }, []);

    useEffect(() => {
        leer();
        timer.current = setInterval(leer, INTERVALO_MS);
        const alVolver = () => { if (!document.hidden) leer(); };
        document.addEventListener('visibilitychange', alVolver);
        return () => {
            if (timer.current) clearInterval(timer.current);
            document.removeEventListener('visibilitychange', alVolver);
        };
    }, [leer]);

    if (activas <= 0) return null;

    return (
        <>
            <style>{`
                @keyframes opem-vip-titila { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: .25; transform: scale(.9); } }
                .opem-vip-alerta { animation: opem-vip-titila 1s ease-in-out infinite; }
                @media (prefers-reduced-motion: reduce) { .opem-vip-alerta { animation: none; } }
            `}</style>
            <button
                type="button"
                className="mr-3 layout-topbar-action rounded-circle p-link p-overlay-badge"
                onClick={() => navigate('/components/operador')}
                title={tituloVip(activas)}
                aria-label={tituloVip(activas)}>
                <i className="pi pi-exclamation-triangle fs-large opem-vip-alerta" style={{ color: '#EF4444' }}></i>
                <span className="p-badge p-component p-badge-danger">{activas > 99 ? '99+' : activas}</span>
            </button>
        </>
    );
};

export default AlertaVipIndicador;
